export default {
  BASE_URL: 'https://snsys.xiujiadian.com/api',
  DINGTALK_CONFIG: {
    client_id: "dinggepvt8jfxxzreiw9",
    corpId: "ding604c3166bcf39424",
    proof: "31D9070BB66A87EDBCEA130716996081",
    redirect_uri: "https://snsys.xiujiadian.com/api/dingding/challenge"
  }
}
